import { z } from 'zod'
import { NOTIFICATION_TYPES } from '../enums'

export const notificationQuerySchema = z.object({
  unreadOnly: z.preprocess(
    (v) => (v === 'true' || v === true ? true : v === 'false' || v === false ? false : false),
    z.boolean().default(false)
  ),
  limit: z.coerce.number().int().min(1).max(100).default(30),
})

export type NotificationQuery = z.infer<typeof notificationQuerySchema>

export type NotificationDto = {
  id: string
  type: (typeof NOTIFICATION_TYPES)[number]
  taskId: string | null
  taskName: string | null
  createdAt: string
  readAt: string | null
}

export type MyDayDto = {
  overdue: import('./task').TaskDto[]
  today: import('./task').TaskDto[]
  thisWeek: import('./task').TaskDto[]
  unreadNotifications: number
}
